/**
 * Banner global de integridad del hash chain del audit trail.
 *
 * Aparece SOLO si `useAuditStore.integridad.ok === false`. Lo mostramos a nivel
 * AppShell (no Dashboard) para que sea visible en cualquier vista que cargue —
 * regulatorio: si el hash chain está corrupto, el operador no debe poder
 * "esconderlo" navegando a otra pantalla.
 *
 * Acción: link directo a /audit donde el Administrador puede ver las entradas
 * rotas y exportar.
 */

import { AlertOctagon } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuditStore } from '@/stores/audit';

export function IntegridadBanner() {
  const navigate = useNavigate();
  const location = useLocation();
  const integridad = useAuditStore((s) => s.integridad);

  if (!integridad || integridad.ok) return null;
  if (location.pathname === '/audit') return null; // ya estás viendo el detalle

  return (
    <div className="border-b border-red-300 bg-red-100 px-8 py-2 text-xs text-red-900">
      <div className="flex items-center gap-2">
        <AlertOctagon className="h-4 w-4 text-red-700" />
        <div className="flex-1">
          <b>Integridad del audit trail comprometida</b>
          {' · '}
          {integridad.rotas.length} entrada
          {integridad.rotas.length !== 1 ? 's' : ''} con hash inconsistente.
          {' '}
          <button
            className="font-semibold underline hover:text-red-700"
            onClick={() => {
              void navigate('/audit');
            }}
          >
            Ver detalle en Audit Trail →
          </button>
        </div>
      </div>
    </div>
  );
}
